import { render, staticRenderFns } from "./AddUseService.vue?vue&type=template&id=67312504&"
import script from "./AddUseService.vue?vue&type=script&lang=js&"
export * from "./AddUseService.vue?vue&type=script&lang=js&"
import style0 from "./AddUseService.vue?vue&type=style&index=0&id=67312504&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports